import { useDispatch, useSelector } from 'react-redux';
import { ThemedButton } from '@/core/page/components/ThemedButton/ThemedButton.default';
import { getDomains } from '@/core/platform/domains/getDomains';
import { Link } from '@/core/routing/components/Link';
import { TLDS } from '@/core/settings/constants';
import { getPlatform, getTLD } from '@/core/settings/utils';
import { Modal } from '@/core/tamagoshi/Modal/Modal';
import { ModalContent } from '@/core/tamagoshi/Modal/ModalContent';
import { ModalFooter } from '@/core/tamagoshi/Modal/ModalFooter';
import { ModalHeader } from '@/core/tamagoshi/Modal/ModalHeader';
import type { Platform } from '@/domains/core/settings/interfaces/Platform';
import { countryDe, countryEs, countryFr, countryIt, countryUk } from '@/domains/customerManagement/components/FormFields/CountryField/translations';
import { selectCustomerProfile } from '@/domains/customerManagement/customerProfile/selectors';
import { hideCrossPlatformPurchaseBlockedModal } from '@/domains/shoppingCart/AddToCart/AddToCart.actions';
import { findOutMoreLinkLabel, findOutMoreLinkUrl, modalContent, modalTitle, switchToPlatformCTALabel } from '@/domains/shoppingCart/AddToCart/components/CrossPlatformPurchaseBlockedModal/translations';
import styles from './CrossPlatfromPurchaseBlockedModal.module.scss';
const translatedPlatformNames: Record<Platform, string> = {
  de: countryDe,
  es: countryEs,
  fr: countryFr,
  gb: countryUk,
  it: countryIt
};
export const CrossPlatformPurchaseBlockedModal = () => {
  const dispatch = useDispatch();
  const {
    platform: userPlatform
  } = useSelector(selectCustomerProfile);
  const closeModal = () => {
    dispatch(hideCrossPlatformPurchaseBlockedModal());
  };
  const {
    domainPro
  } = getDomains();
  const targetPlatform = userPlatform?.toLowerCase() as Platform ?? getPlatform();
  const targetPlatformUrl = `https://${domainPro.replace(getTLD(), TLDS[targetPlatform])}/`;
  const translatedTargetPlatformName = translatedPlatformNames[targetPlatform];
  return <Modal onClose={closeModal}>
      <ModalHeader>{modalTitle}</ModalHeader>
      <ModalContent>
        <p>
          {modalContent.format({
          platformName: translatedTargetPlatformName
        })}
        </p>
        <Link href={findOutMoreLinkUrl} data-testid="find-out-more-link" className={styles.link} target="_blank">
          {findOutMoreLinkLabel}
        </Link>
      </ModalContent>
      <ModalFooter>
        <ThemedButton href={targetPlatformUrl} tag={Link} data-testid="go-to-platform-cta">
          {switchToPlatformCTALabel.format({
          platformName: translatedTargetPlatformName
        })}
        </ThemedButton>
      </ModalFooter>
    </Modal>;
};
CrossPlatformPurchaseBlockedModal.displayName = 'CrossPlatformPurchaseBlockedModal';